export default class ObjectCollection {
  #items: Object = {};

  /**
   * Create a new instance of an ObjectCollection
   */
  constructor(items: ?Object) {
    if (!items) return;
    this.#items = items;
  }

  /**
   * Get all items.
   */
  all(): Object {
    return this.#items;
  }

  /**
   * Get a item according to a key.
   */
  get(key: string): ?string {
    return this.#items[key];
  }

  /**
   * Store one or multiple items to the array.
   *
   * @param items
   */
  add(items: Object): void {
    for (const [key, value] of Object.entries(items)) {
      this.#items[key] = value;
    }
  }

  /**
   * Clear the collection.
   */
  clear(): void {
    this.#items = {};
  }

  /**
   * Count the items of the collection.
   */
  count(): number {
    return Object.keys(this.#items).length;
  }
}
